import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { IoWarningOutline } from "react-icons/io5";
export default function ErrorPage() {
  let navigate = useNavigate()
  useEffect(()=>{
    
var time = setTimeout(()=>{
      if(window.location.pathname==="/admin" || window.location.pathname==="/my-account")  {
        if(localStorage.getItem("login") && localStorage.getItem("role")==="@A*_s&_k!=!@h!-%" && window.location.pathname==="/my-account"){
          if(localStorage.getItem("@A*_s&_k!=!@h!-%"))
            navigate(0)
          else
            navigate("/my-account")
        }
        else if(window.location.pathname==="/admin" && localStorage.getItem("login"))
        navigate (0)
      else
      navigate("/login")

      }
    },500)
    return ()=> clearTimeout(time)
  },[window.location.pathname])
  return (
   <> 
  

    <div className="container">
      <div className="error-page-hero mt-5">
            <img src="/images/payment/404-EROR_.png" loading="lazy" title='error page Title' alt="Error 404 page image for V Hotel The Grand Shoba" />
        </div>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-12 justify-content-center">
          <IoWarningOutline  className=' display-1 text-danger error-icon mb-2 text-center'/>
          <h1 className=" display-2 mb-4 text-danger"> 404</h1>
            <h1 className="mb-2">Page Not Found</h1>
              <p className="mb-4 text-center">
              We're sorry, the page you have looked for does not exist in our
              website! Maybe go to our home page or try to use a search?
            </p>
        </div>
            <Link className=" btn error-btn w-100" to="/">Go Back To Home</Link>

      </div>
    </div>

   </>
  )
}